import { render, staticRenderFns } from "./TheCategory.vue?vue&type=template&id=fe801cfe&scoped=true"
import script from "./TheCategory.vue?vue&type=script&lang=ts"
export * from "./TheCategory.vue?vue&type=script&lang=ts"
import style0 from "./TheCategory.vue?vue&type=style&index=0&id=fe801cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe801cfe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSearchFiltersTheAlert: require('/usr/src/nuxt-app/components/core/search/filters/TheAlert.vue').default})
